import React from 'react';
import Label from '../Label';
import { DifferentTZSWrapper } from './styles';


const DifferentTZS = () => (
  <DifferentTZSWrapper>
    <Label
        label="* La data dell'evento potrebbe differire per effetto del fuso orario."
        size={0.8}
        margin="0"
        color="mainFontColor"
        alignSelf="flex-start"
        lineHeight={1.2}
      />
  </DifferentTZSWrapper>
);

export default DifferentTZS;
